export default __webpack_public_path__ + "static/media/Boots of Black Spite.04459672.jpg";